module.exports = __webpack_public_path__ + "static/media/undraw_mujer.45b2e0bb.png";